import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70edd7fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_work" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","margin":"20px 0 10px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"120px","text-align":"center","font-weight":"600"} }, [
  /*#__PURE__*/_createElementVNode("div", null, "周工作内容"),
  /*#__PURE__*/_createElementVNode("div", { style: {"border-bottom":"3px solid #0585fc","margin":"0 5px"} })
], -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("+ 添加周工作内容")
const _hoisted_5 = { class: "list_search" }
const _hoisted_6 = {
  class: "flexAlign",
  style: {"margin-bottom":"15px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"8px"} }, "部门：", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 8px 0 16px"} }, "日期：", -1))
const _hoisted_9 = {
  key: 0,
  style: {"color":"#909399","font-size":"12px","margin-left":"12px"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_11 = { class: "cell-pre" }
const _hoisted_12 = { class: "cell-pre" }
const _hoisted_13 = { class: "cell-pre" }
const _hoisted_14 = { class: "cell-pre" }
const _hoisted_15 = { class: "cell-pre" }
const _hoisted_16 = { class: "cell-pre" }
const _hoisted_17 = { class: "cell-pre" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_19 = {
  class: "flexEnd",
  style: {"padding":"15px 0 0"}
}
const _hoisted_20 = { style: {"color":"#909399","font-size":"12px"} }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("保存工作内容")

import { ref, computed, onMounted } from 'vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	import { reqWorkRecordsList, reqWorkRecordsDelete } from '@/api/api';
	import { requestMyuser } from '@/api/api';
	import { requestgetselfrole } from '@/api/api';
	import { reqQueryByUserIdworkrecords, reqSaveWorkRecords, reqWorkRecordsMyDept } from '@/api/api';
	import { requestDDDepartlist } from '@/api/xmApi';

	
export default /*#__PURE__*/_defineComponent({
  name: 'WeekRecordsList',
  setup(__props) {

	const loading = ref(false)
	const tableData = ref<any[]>([])
	const weekDate = ref<Date | null>(null)
	const deptid = ref('')
	const DDDepartlist = ref<any[]>([])
	const myUserId = ref('')
	const isAdmin = ref(false)

	// 分页
	const pageIndex = ref(1)
	const pageSize = ref(10)
	const totalCount = ref(0)
	const handleSizeChange = (val: number) => {
		pageSize.value = val
		pageIndex.value = 1
		applyPaging()
	}
	const handleCurrentChange = (val: number) => {
		pageIndex.value = val
		applyPaging()
	}
	// 聚合后的全量数据（分页前）
	const allAggData = ref<any[]>([])
	const applyPaging = () => {
		const start = (pageIndex.value - 1) * pageSize.value
		tableData.value = allAggData.value.slice(start, start + pageSize.value)
	}

	// 计算某日期所在周的周一（YYYY-MM-DD）
	const calcWeekStart = (d: Date): string => {
		const dt = new Date(d)
		const day = dt.getDay()
		const diff = (day + 6) % 7
		dt.setDate(dt.getDate() - diff)
		const y = dt.getFullYear()
		const m = String(dt.getMonth() + 1).padStart(2, '0')
		const dd = String(dt.getDate()).padStart(2, '0')
		return `${y}-${m}-${dd}`
	}
	// 计算某日期所在周的周日（YYYY-MM-DD）
	const calcWeekEnd = (d: Date): string => {
		const dt = new Date(d)
		const day = dt.getDay()
		const diff = (day + 6) % 7
		dt.setDate(dt.getDate() - diff + 6)
		const y = dt.getFullYear()
		const m = String(dt.getMonth() + 1).padStart(2, '0')
		const dd = String(dt.getDate()).padStart(2, '0')
		return `${y}-${m}-${dd}`
	}
	const weekStart = computed(() => {
		if (!weekDate.value) return ''
		return calcWeekStart(weekDate.value)
	})
	const weekStartText = computed(() => weekStart.value)
	const weekEndText = computed(() => {
		if (!weekDate.value) return ''
		return calcWeekEnd(weekDate.value)
	})

	// 是否可删除：创建人本人或管理员
	const canDelete = (row: any) => {
		return isAdmin.value || (myUserId.value && row.user_id === myUserId.value)
	}

	// 查询列表（weekstart 为空时查全部周；deptid 为空时查全部部门）
	const loadList = () => {
		loading.value = true
		reqWorkRecordsList({
			weekstart: weekStart.value,
			deptid: deptid.value
		}).then((res: any) => {
			loading.value = false
			if (res.status === 1 && res.datalist) {
				// 后端返回平铺明细（user+dept+week+weekday+content），按 部门+人+周 聚合为一行
				const map: {[key: string]: any} = {}
				const arr: any[] = []
				res.datalist.forEach((item: any) => {
					const key = `${item.user_id}|${item.dept_id}|${item.week_start}`
					if (!map[key]) {
						map[key] = {
							user_id: item.user_id,
							username: item.username || item.createname || '-',
							dept_id: item.dept_id,
							dept_name: item.dept_name || '-',
							week_start: item.week_start,
							records1: '', records2: '', records3: '', records4: '',
							records5: '', records6: '', records7: ''
						}
						arr.push(map[key])
					}
					const k = `records${item.weekday}`
					if (map[key].hasOwnProperty(k)) {
						map[key][k] = item.content || ''
					}
				})
				allAggData.value = arr
				totalCount.value = arr.length
				pageIndex.value = 1
				applyPaging()
			} else {
				allAggData.value = []
				totalCount.value = 0
				tableData.value = []
			}
		}).catch(() => {
			loading.value = false
		})
	}

	// ===== 添加/编辑周工作内容（弹窗，原"工作事项"填报页）=====
	const addDialogVisible = ref(false)
	const addSaveLoading = ref(false)
	const addDeptid = ref('')
	const addWeekDate = ref<any>(null)
	const myDeptId = ref('')// 当前登录用户所在部门（弹窗默认选中）
	const weekDays = [
		{ key: 'records1', label: '周一' },
		{ key: 'records2', label: '周二' },
		{ key: 'records3', label: '周三' },
		{ key: 'records4', label: '周四' },
		{ key: 'records5', label: '周五' },
		{ key: 'records6', label: '周六' },
		{ key: 'records7', label: '周日' }
	]
	const emptyAddForm = () => ({
		records1: '', records2: '', records3: '', records4: '', records5: '', records6: '', records7: ''
	})
	const addForm = ref<any>(emptyAddForm())

	const addWeekStart = computed(() => {
		if (!addWeekDate.value) return calcWeekStart(new Date())
		return calcWeekStart(addWeekDate.value)
	})
	const addWeekStartText = computed(() => addWeekStart.value)
	const addWeekEndText = computed(() => {
		if (!addWeekDate.value) return calcWeekEnd(new Date())
		return calcWeekEnd(addWeekDate.value)
	})

	// 打开弹窗：默认当前周 + 本人部门，并带入该部门该周已填报内容
	const openAddDialog = () => {
		addWeekDate.value = new Date()
		if (!addDeptid.value) addDeptid.value = myDeptId.value || deptid.value || ''
		addForm.value = emptyAddForm()
		addDialogVisible.value = true
		loadAddRecords()
	}
	// 加载指定部门+周的已填报内容
	const loadAddRecords = () => {
		if (!addDeptid.value) return
		reqQueryByUserIdworkrecords({
			deptid: addDeptid.value,
			weekstart: addWeekStart.value
		}).then((res: any) => {
			if (res.status === 1 && res.datalist) {
				addForm.value = emptyAddForm()
				res.datalist.forEach((item: any) => {
					const key = `records${item.weekday}`
					if (addForm.value.hasOwnProperty(key)) {
						addForm.value[key] = item.content || ''
					}
				})
			}
		}).catch(() => {})
	}
	// 保存
	const saveAddRecords = () => {
		if (!addDeptid.value) {
			ElMessage.warning('请先选择部门')
			return
		}
		addSaveLoading.value = true
		const deptObj = DDDepartlist.value.find((d: any) => String(d.dept_id) === String(addDeptid.value))
		reqSaveWorkRecords({
			deptid: addDeptid.value,
			deptname: deptObj ? deptObj.name : '',
			weekstart: addWeekStart.value,
			records1: addForm.value.records1,
			records2: addForm.value.records2,
			records3: addForm.value.records3,
			records4: addForm.value.records4,
			records5: addForm.value.records5,
			records6: addForm.value.records6,
			records7: addForm.value.records7
		}).then((res: any) => {
			addSaveLoading.value = false
			if (res.status === 1) {
				ElMessage.success('保存成功')
				addDialogVisible.value = false
				loadList()
			} else {
				ElMessage.error(res.msg || '保存失败')
			}
		}).catch(() => {
			addSaveLoading.value = false
			ElMessage.error('网络异常')
		})
	}

// 删除（创建人或管理员）
	const delRecord = (row: any) => {
		ElMessageBox.confirm(`确定删除 ${row.username}（${row.dept_name}）${row.week_start} 这一周的填报内容吗？`, '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			reqWorkRecordsDelete({
				userid: row.user_id,
				deptid: row.dept_id,
				weekstart: row.week_start
			}).then((res: any) => {
				if (res.status === 1) {
					ElMessage.success('删除成功')
					loadList()
				} else {
					ElMessage.error(res.msg || '删除失败')
				}
			})
		}).catch(() => {})
	}

	onMounted(() => {
		// 部门下拉（用于筛选）
		requestDDDepartlist({}).then((res: any) => {
			if (res.status === 1 && res.datalist) {
				DDDepartlist.value = res.datalist
			}
		})
		// 当前用户信息（判断是否为创建人）
		requestMyuser({}).then((res: any) => {
			if (res.status === 1 && res.datalist && res.datalist[0]) {
				myUserId.value = res.datalist[0].id
			}
		})
		// 当前角色（判断是否管理员）
		requestgetselfrole({}).then((res: any) => {
			if (res.status === 1) {
				isAdmin.value = res.datalist === '管理员'
			}
		})
		// 当前用户所在部门：填报弹窗默认选中
		reqWorkRecordsMyDept({}).then((res: any) => {
			if (res.status === 1 && res.datalist && res.datalist.length > 0) {
				myDeptId.value = String(res.datalist[0].dept_id)
			}
		})
		loadList()
	})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: openAddDialog
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_el_select, {
          modelValue: deptid.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((deptid).value = $event)),
          placeholder: "全部部门",
          size: "small",
          clearable: "",
          style: {"width":"200px"},
          onChange: loadList
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "全部部门",
              value: ""
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(DDDepartlist.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.name,
                value: String(item.dept_id)
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_8,
        _createVNode(_component_el_date_picker, {
          modelValue: weekDate.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((weekDate).value = $event)),
          type: "week",
          format: "YYYY年第WW周",
          placeholder: "选择周（不选查全部）",
          style: {"width":"220px"},
          size: "small"
        }, null, 8, ["modelValue"]),
        (_unref(weekStartText))
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "本周起止：" + _toDisplayString(_unref(weekStartText)) + " 至 " + _toDisplayString(_unref(weekEndText)), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          plain: "",
          onClick: loadList,
          style: {"margin-left":"15px"}
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "empty-text": "暂无数据",
      data: tableData.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "60",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "week_start",
          label: "周起始日期",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "dept_name",
          label: "部门",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "username",
          label: "填报人",
          width: "90"
        }),
        _createVNode(_component_el_table_column, {
          label: "周一",
          "min-width": "140",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_11, _toDisplayString(scope.row.records1 || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "周二",
          "min-width": "140",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_12, _toDisplayString(scope.row.records2 || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "周三",
          "min-width": "140",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_13, _toDisplayString(scope.row.records3 || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "周四",
          "min-width": "140",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_14, _toDisplayString(scope.row.records4 || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "周五",
          "min-width": "140",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_15, _toDisplayString(scope.row.records5 || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "周六",
          "min-width": "140",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_16, _toDisplayString(scope.row.records6 || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "周日",
          "min-width": "140",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_17, _toDisplayString(scope.row.records7 || '-'), 1)
          ]),
          _: 1
        }),
        (isAdmin.value || myUserId.value)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "操作",
              width: "80",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                (canDelete(scope.row))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "danger",
                      link: "",
                      size: "small",
                      onClick: ($event: any) => (delRecord(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 50, 100],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: totalCount.value
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: addDialogVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addDialogVisible).value = $event)),
      title: "周工作内容填报",
      width: "900px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (addDialogVisible.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveAddRecords,
          loading: addSaveLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: addForm.value,
          "label-width": "80px",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              gutter: 20,
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "部门" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: addDeptid.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addDeptid).value = $event)),
                          placeholder: "请选择部门",
                          style: {"width":"100%"},
                          onChange: loadAddRecords
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(DDDepartlist.value, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.name,
                                value: String(item.dept_id)
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "日期" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: addWeekDate.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addWeekDate).value = $event)),
                          type: "week",
                          format: "YYYY年第WW周",
                          placeholder: "选择周",
                          style: {"width":"100%"},
                          onChange: loadAddRecords
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 8,
                  style: {"line-height":"32px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_20, "本周起止：" + _toDisplayString(_unref(addWeekStartText)) + " 至 " + _toDisplayString(_unref(addWeekEndText)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, (day, index) => {
                  return _createVNode(_component_el_col, {
                    span: 8,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: day.label
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            rows: 3,
                            modelValue: addForm.value[day.key],
                            "onUpdate:modelValue": ($event: any) => ((addForm.value[day.key]) = $event),
                            placeholder: "请输入本周工作内容"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})